/** Strings for shared opening-hours schedules, holidays and closures (#1256, #1231). */
export const translationLivechat_sv_schedules = {
  livechatOpeningHours: "Öppettider",
  livechatOpeningHoursHint: "Schema, helgdagar och stängningar som delas av chatbotar",
  livechatHolidaysClosures: "Helgdagar och specialöppettider",
  livechatSchedulesDescription:
    "Varje chatbot följer ett schema eller behåller sina egna öppettider. En ändring gäller för alla chatbotar på schemat på en gång.",
  livechatSchedulesEmpty: "Inga schema ännu. Skapa ett och välj vilka chatbotar som ska följa det.",
  livechatSchedulesLoadFailed: "Kunde inte ladda scheman.",
  livechatScheduleNew: "Nytt schema",
  livechatScheduleNewName: "Nytt schema",
  livechatScheduleName: "Schemanamn",
  livechatScheduleTimezone: "Tidszon",
  livechatScheduleChatbotCount: "{count} chatbotar",
  livechatScheduleClosureCount: "{count} kommande stängningar",
  livechatScheduleNoClosures: "Inga stängningar",
  livechatScheduleClosedNow: "Stängt nu: {name}",
  livechatScheduleTabWeekly: "Veckotider",
  livechatScheduleTabClosures: "Helgdagar och specialöppettider",
  livechatScheduleTabChatbots: "Chatbotar",
  livechatScheduleSave: "Spara schema",
  livechatScheduleSaving: "Sparar…",
  livechatScheduleDelete: "Ta bort schema",
  livechatScheduleDeleteConfirm:
    'Ta bort "{name}"? Dess chatbotar behåller veckotiderna som sina egna. Helgdagar och stängningar tas bort.',
  livechatScheduleDeleteConfirmAction: "Ta bort",
  livechatScheduleAll: "Alla schema",
  livechatScheduleNameTaken: "Det finns redan ett schema med det namnet.",
  livechatScheduleSaveFailed: "Kunde inte spara schemat.",
  livechatScheduleChatbotsHelp:
    "Att bocka i en chatbot som följer ett annat schema flyttar den hit. En chatbot du bockar ur behåller det här schemats tider som sina egna.",
  livechatScheduleChatbotsSave: "Spara chatbotar",
  livechatScheduleOnOther: "På {name}",
  livechatScheduleSelected: "{count} av {total} chatbotar följer det här schemat",
  livechatScheduleUnsaved: "Osparade ändringar",
  livechatClosureAdd: "Lägg till stängning",
  livechatClosureEdit: "Redigera stängning",
  livechatClosureUpcoming: "Kommande",
  livechatClosurePast: "Tidigare",
  livechatClosureShow: "Visa",
  livechatClosureEmpty:
    "Inget planerat. Lägg till en stängning eller specialöppettider för specifika datum.",
  livechatClosurePastEmpty: "Inga tidigare stängningar eller specialöppettider.",
  livechatClosureName: "Namn",
  livechatClosureStart: "Startdatum",
  livechatClosureEnd: "Slutdatum",
  livechatClosureRepeat: "Upprepa varje år",
  livechatClosureHours: "Öppettider under dessa datum",
  livechatClosureClosedAllDay: "Stängt hela dagen",
  livechatClosureCustomHours: "Specialöppettider",
  livechatClosureCustomHelp: "Livechat är öppen bara under dessa tidsintervall på dessa datum.",
  livechatClosureClosedHelp: "Livechat är stängt hela dagen. Chatboten fortsätter att svara.",
  livechatClosureAddSlot: "Lägg till tidsintervall",
  livechatClosureSlotStart: "Intervall {index} öppnar",
  livechatClosureSlotEnd: "Intervall {index} stänger",
  livechatClosureSlotRemove: "Ta bort intervall {index}",
  livechatClosureMessage: "Meddelande när en besökare ber om livechat",
  livechatClosureRegularMessage: "Vanligt stängt meddelande",
  livechatClosureOwnMessage: "Eget meddelande",
  livechatClosureRegularHelp:
    "Boten använder varje kontaktformulärts vanliga stängningsmeddelande.",
  livechatClosureOwnLabel: "Eget meddelande",
  livechatClosureInsert: "Infoga",
  livechatClosurePreview: "Text som boten använder den {date}",
  livechatClosureSave: "Spara",
  livechatClosureDelete: "Ta bort stängning",
  livechatClosureDeleteConfirm: 'Ta bort "{name}"?',
  livechatClosureEveryYear: "Varje år",
  livechatClosureActive: "Aktiv nu",
  livechatClosureAllDay: "Hela dagen",
  livechatClosureClosed: "Stängt",
  livechatClosureCustom: "Öppen {hours}",
  livechatClosureOwnShort: "Eget meddelande",
  livechatClosureRegularShort: "Vanligt meddelande",
  livechatClosureOptions: "Alternativ för {name}",
  livechatClosureSaveFailed: "Kunde inte spara stängningen.",
  livechatClosureInvalid:
    "Kontrollera datum och tider: slutdatumet måste vara samma eller efter startdatumet och högst ett år senare, och intervallen får inte överlappa.",
  livechatClosureLimit: "Det här schemat har redan maximalt antal stängningar.",
  livechatSettingsSchedule: "Öppettider",
  livechatSettingsScheduleCustom: "Anpassat för den här chatboten",
  livechatSettingsScheduleFollowing:
    'Följer "{name}". Att redigera schemat ändrar alla {count} chatbotar på det.',
  livechatSettingsScheduleEdit: "Redigera schema",
  livechatSettingsScheduleShare: "Dela dessa tider som ett schema",
  livechatSettingsScheduleShareHint:
    "Helgdagar och stängningar tillhör scheman. Skapa ett från dessa tider för att lägga till dem.",
  livechatSettingsScheduleSaveFailed: "Kunde inte ändra schemat.",
  livechatAvailabilityClosedFor: "{name} till {time}",
  livechatScheduleNameRequired: "Ge schemat ett namn.",
  livechatScheduleTimezoneInvalid: "Okänd tidszon. Välj en från listan, t.ex. Europe/Copenhagen.",
  livechatScheduleDiscardTitle: "Ignorera dina ändringar?",
  livechatScheduleDiscardText: "Du har osparade ändringar i det här schemat.",
  livechatScheduleKeepEditing: "Fortsätt redigera",
  livechatScheduleDiscard: "Ignorera",
  livechatScheduleReplacesOwnHours:
    "{count} av de valda chatbotarna har egna öppettider. När du sparar får de schemats tider i stället, och deras egna tider kan inte återställas.",
  livechatSettingsScheduleReplacesOwnHours:
    "När du sparar får chatboten schemats tider i stället för sina egna. Dess egna tider kan inte återställas.",
  livechatClosureNameRequired: "Ge stängningen ett namn.",
  livechatClosureDatesInvalid:
    "Slutdatumet måste vara samma eller efter startdatumet och högst ett år senare.",
  livechatClosureNoSlots: "Lägg till minst ett tidsintervall, eller välj Stängt hela dagen.",
  livechatClosureSlotsInvalid:
    "Varje tidsintervall måste sluta efter det börjar, och intervallen får inte överlappa.",
  livechatScheduleSelectAll: "Välj alla",
  livechatScheduleSaved: '"{name}" sparades.',
  livechatScheduleChatbotsSaved: "Chatbotar sparade.",
  livechatClosureSaved: "Stängning sparad.",
  livechatSpecialHoursSaved: "Specialöppettider sparade.",
  livechatSpecialHoursAdd: "Lägg till specialöppettider",
  livechatSpecialHoursEdit: "Redigera specialöppettider",
  livechatScheduleNoChatbots:
    "Inga chatbotar följer det här schemat ännu, så dess tider används inte.",
  livechatScheduleChooseChatbots: "Välj chatbotar",
  livechatTimezoneSearch: "Sök tidszoner",
  livechatTimezoneEmpty: "Ingen tidszon hittades.",
};
